import { Component, Inject, OnInit, NgZone } from '@angular/core';
import { RmsModule } from '@rms';
import { WebService, lastValueFrom, PromptService } from '@services';
import { RmsPulldownRef } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-cupping-details',
  imports: [RmsModule, MatMenuModule],
  templateUrl: './cupping-details.component.html',
  styleUrl: './cupping-details.component.scss'
})
export class CuppingDetailsComponent implements OnInit {
  CuppingSessionDetails: any
  InventoryFlavorNotes: any[] = [];
  AllFlavorNotes: any[] = [];
  SelectedFlavorNotes: any[] = [];
  isOverallManuallySet = false;
  rejectionReasonRequired = false;
  cancel() { this.pulldownRef.close(); }
  selectionCounter: number = 0;
  constructor(private pulldownRef: RmsPulldownRef, @Inject(RMS_PULLDOWN_DATA) public data: any, private web: WebService, private prompt: PromptService, private ngZone: NgZone) {
    this.CuppingSessionDetails = this.data.coffee || {};
    this.AllFlavorNotes = (this.data.flavorNotes || []).map((note: any) => ({ ...note, selected: false, order: null }));
  }
  async ngOnInit() {
    console.log(this.CuppingSessionDetails);
    if (this.CuppingSessionDetails.flavorNotes) {
      this.CuppingSessionDetails.flavorNotes.forEach((note: any) => {
        const matchingNote = this.AllFlavorNotes.find((n: any) => n.labelName === note.label);
        if (matchingNote) {
          matchingNote.selected = true;
          matchingNote.order = note.order;
        }
      });
      const selected = this.AllFlavorNotes
        .filter(n => n.selected)
        .sort((a, b) => a.order - b.order);

      this.selectionCounter = selected.length;
      // ✅ assign order after initial load
    }
    this.CuppingSessionDetails = {
      ...this.CuppingSessionDetails,
      Acidity: this.CuppingSessionDetails.Acidity ?? 6,
      Body: this.CuppingSessionDetails.Body ?? 6,
      Aftertaste: this.CuppingSessionDetails.Aftertaste ?? 6,
      Sweetness: this.CuppingSessionDetails.Sweetness ?? 6,
      Overall: this.CuppingSessionDetails.Overall ?? 6,
    }
    setTimeout(() => {
      this.onUpdated();
    })

  }

  UpdateOverall() {
    if (this.isOverallManuallySet) return;

    this.CuppingSessionDetails.Overall =
      ((this.CuppingSessionDetails.Acidity ?? 0) +
        (this.CuppingSessionDetails.Body ?? 0) +
        (this.CuppingSessionDetails.Aftertaste ?? 0) +
        (this.CuppingSessionDetails.Sweetness ?? 0)) / 4;
  }

  OnOverallChanged() {
    this.isOverallManuallySet = true;
  }
  ResetOverall() {
    if (this.isOverallManuallySet) {
      this.isOverallManuallySet = false;
      this.UpdateOverall();
    }
  }

  toggleFlavorNote(note: any) {
    if (note.selected) {
      note.selected = false;
      note.order = null;

      // reflow remaining selections
      const selected = this.AllFlavorNotes
        .filter(n => n.selected)
        .sort((a, b) => a.order - b.order);

      selected.forEach((n, i) => n.order = i + 1);

      this.selectionCounter = selected.length;
    } else {
      note.selected = true;
      this.selectionCounter++;
      note.order = this.selectionCounter;
    }
  }


  async onApproveSample() {
    if (
      (this.CuppingSessionDetails.Mold ?? 0) > 0 ||
      (this.CuppingSessionDetails.Phenol ?? 0) > 0 ||
      (this.CuppingSessionDetails.Ferment ?? 0) > 0 ||
      (this.CuppingSessionDetails.Potato ?? 0) > 0
    ) {
      const { closed$ } = await this.prompt.open({
        promptText: 'This sample has been marked with a defect. Are you sure you want to approve it?',
        buttons: [{ label: 'Yes', value: true, buttonClass: 'btn-bg-green' }]
      });

      const result = await lastValueFrom(closed$);

      if (!result) return;

      // If user confirms, continue (approved stays true)
    }

    this.SelectedFlavorNotes = this.AllFlavorNotes
      .filter((note: any) => note.selected)
      .sort((a, b) => a.order - b.order)
      .map((note: any) => ({ label: note.labelName, order: note.order }));

    this.pulldownRef.close({
      ...this.CuppingSessionDetails,
      Completed: true,
      WasApproved: true,
      flavorNotes: this.SelectedFlavorNotes,
      Recup: false
    });
  }

  onRejectSample() {
    if (!String(this.CuppingSessionDetails.CuppingNotes || "").trim()) { this.rejectionReasonRequired = true; return; }

    this.SelectedFlavorNotes = this.AllFlavorNotes
      .filter((note: any) => note.selected)
      .sort((a, b) => a.order - b.order)
      .map((note: any) => { return { label: note.labelName, order: note.order } });

    this.pulldownRef.close({ ...this.CuppingSessionDetails, Completed: true, WasApproved: false, flavorNotes: this.SelectedFlavorNotes, Recup: false });
    }
  onRecupSample() {

    this.SelectedFlavorNotes = this.AllFlavorNotes
      .filter((note: any) => note.selected)
      .sort((a, b) => a.order - b.order)
      .map((note: any) => { return { label: note.labelName, order: note.order } });

      this.pulldownRef.close({ ...this.CuppingSessionDetails, Completed: true, WasApproved: false, DateRoasted: null, flavorNotes: this.SelectedFlavorNotes, Recup: true });
  }
  get scaaScoreValues(): number[] {
    return [
      this.CuppingSessionDetails?.Acidity ?? 0,
      this.CuppingSessionDetails?.Body ?? 0,
      this.CuppingSessionDetails?.Sweetness ?? 0,
      this.CuppingSessionDetails?.Aftertaste ?? 0,
      this.CuppingSessionDetails?.Overall ?? 0
    ];
  }

  get scaaSliderSum(): number {
    const sum = this.scaaScoreValues.reduce((total, value) => total + value, 0);
    return Number(sum.toFixed(2));
  }

  get scaaSliderAverage(): number {
    const average = this.scaaSliderSum / 5;
    return Number(average.toFixed(2));
  }

  get scaaWeightedScore(): number {
    const weighted = this.scaaSliderAverage * 7;
    return Number(weighted.toFixed(2));
  }

  get scaaDefaultScore(): number {
    return 30;
  }

  get scaaLiveTotal(): number {
    const total = this.scaaWeightedScore + this.scaaDefaultScore;
    return Number(total.toFixed(2));
  }
  onUpdated() {
    this.CuppingSessionDetails.SCAATotal = this.scaaLiveTotal;

    this.SelectedFlavorNotes = this.AllFlavorNotes
      .filter((note: any) => note.selected)
      .sort((a, b) => a.order - b.order)
      .map((note: any) => ({ label: note.labelName, order: note.order }));

    this.pulldownRef.sendData({ ...this.CuppingSessionDetails, flavorNotes: this.SelectedFlavorNotes });
  }
}
